import { useReactiveVar } from '@apollo/client';

import { useMyPromoCodesQuery } from 'core/graphql';
import { authState } from 'core/state';
import { isCareerViewer } from 'core/hooks/CareerCenter/isCareerViewer';

export interface IPromoCode {
  id: string;
  code: string;
  // 🔴 Запрос уходит ТОЛЬКО зрителю карьерного раздела. Без этого условия
  // преподаватель, открывший /growth по прямому адресу, получал пачку
  // молчаливых PermissionDenied и полупустой экран: GraphQL-ошибки в клиенте
  // не редиректят и не показывают тост, поэтому симптом выглядел как «раздел
  // сломан», а в консоли лежала причина, которую никто не читает.
  /** 'issued' — можно назвать менеджеру, 'redeemed' — уже применён. */
  status: string;
  expiresAt: string | null;
  campaignTitle: string;
  campaignDescription: string;
  discountKind: string;
  discountValue: number;
  currency: string;
}

/**
 * ТЗ 0039 шаг 6 — «Мои бонусы».
 *
 * Код НЕ применяет скидку сам: студент называет его менеджеру при оформлении.
 * Так решено владельцем, и текст на карточке обязан это говорить прямо —
 * иначе человек ждёт автоматической скидки и считает систему сломанной.
 */
export const usePromoCodes = () => {
  const { active_role, isDemoUser } = useReactiveVar(authState);

  const { data, loading } = useMyPromoCodesQuery({
    fetchPolicy: 'cache-and-network',
    skip: !isCareerViewer(active_role) || Boolean(isDemoUser),
  });

  return {
    codes: (data?.myPromoCodes ?? []).map((row) => ({
      id: row.id,
      code: row.code,
      status: row.status,
      expiresAt: row.expiresAt ?? null,
      campaignTitle: row.campaignTitle,
      campaignDescription: row.campaignDescription,
      discountKind: row.discountKind,
      discountValue: row.discountValue,
      currency: row.currency,
    })) as IPromoCode[],
    loading,
  };
};
